// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Settings Page Styles */
.settings-container {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }
  
  /* Settings Tabs */
  .settings-tabs .nav-tabs {
    border-bottom: 1px solid #e9ecef;
    padding: 0 1rem;
  }
  
  .settings-tabs .nav-link {
    color: #6c757d;
    border: none;
    border-bottom: 3px solid transparent;
    padding: 1rem 1.5rem;
    font-weight: 500;
    transition: all 0.3s ease;
  }
  
  .settings-tabs .nav-link:hover {
    color: #333;
  }
  
  .settings-tabs .nav-link.active {
    color: #1e3a5f;
    border-bottom-color: #1e3a5f;
    background-color: transparent;
  }
  
  /* Settings Content */
  .settings-content {
    padding: 2rem;
  }
  
  /* Profile Settings */
  .cover-photo-container {
    position: relative;
  }
  
  .cover-photo {
    height: 200px;
    background-color: #295478;
    border-radius: 8px;
    position: relative;
  }
  
  .profile-photo-container {
    position: absolute;
    bottom: -15px;
    left: 30px;
  }
  
  .profile-photo {
    width: 100px;
    height: 100px;
    background-color: #f8f9fa;
    border: 4px solid white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  
  .upload-icon {
    color: #6c757d;
    font-size: 1.5rem;
  }
  
  .bio-toolbar {
    border: 1px solid #ddd;
    border-bottom: none;
    border-radius: 6px 6px 0 0;
    padding: 0.5rem;
    background-color: #f8f9fa;
  }
  
  /* Wishlist Styles */
  .wishlist-course-card .card {
    border: 1px solid #e9ecef;
    border-radius: 12px;
    overflow: hidden;
    transition: box-shadow 0.3s ease;
  }
  
  .wishlist-course-card .card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .wishlist-course-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    min-height: 200px;
  }
  
  .instructor-avatar {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    object-fit: cover;
  }
  
  .instructor-name {
    font-weight: 500;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .settings-tabs .nav-link {
      padding: 0.75rem 1rem;
      font-size: 0.9rem;
    }
  
    .settings-content {
      padding: 1.5rem;
    }
  
    .profile-photo {
      width: 80px;
      height: 80px;
    }
  
    .cover-photo {
      height: 150px;
    }
  
    .profile-photo-container {
      bottom: -40px;
      left: 20px;
    }
  
    .wishlist-course-image {
      min-height: 150px;
    }
  }
  
  @media (max-width: 576px) {
    .settings-tabs .nav {
      flex-wrap: nowrap;
      overflow-x: auto;
    }
  
    .settings-tabs .nav-link {
      white-space: nowrap;
      padding: 0.5rem 0.75rem;
      font-size: 0.85rem;
    }
  
    .settings-content {
      padding: 1rem;
    }
  
    .cover-photo {
      height: 120px;
    }
  
    .profile-photo {
      width: 70px;
      height: 70px;
    }
  
    .profile-photo-container {
      bottom: -35px;
      left: 15px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/settings.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,iBAAiB;IACjB,mBAAmB;IACnB,wCAAwC;IACxC,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,oCAAoC;IACpC,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA,qBAAqB;EACrB;IACE,aAAa;EACf;;EAEA,qBAAqB;EACrB;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,0BAA0B;IAC1B,eAAe;IACf,yBAAyB;EAC3B;;EAEA,oBAAoB;EACpB;IACE,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE;MACE,qBAAqB;MACrB,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;MACb,UAAU;IACZ;;IAEA;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,aAAa;MACb,UAAU;IACZ;EACF","sourcesContent":["/* Settings Page Styles */\n.settings-container {\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n  }\n  \n  /* Settings Tabs */\n  .settings-tabs .nav-tabs {\n    border-bottom: 1px solid #e9ecef;\n    padding: 0 1rem;\n  }\n  \n  .settings-tabs .nav-link {\n    color: #6c757d;\n    border: none;\n    border-bottom: 3px solid transparent;\n    padding: 1rem 1.5rem;\n    font-weight: 500;\n    transition: all 0.3s ease;\n  }\n  \n  .settings-tabs .nav-link:hover {\n    color: #333;\n  }\n  \n  .settings-tabs .nav-link.active {\n    color: #1e3a5f;\n    border-bottom-color: #1e3a5f;\n    background-color: transparent;\n  }\n  \n  /* Settings Content */\n  .settings-content {\n    padding: 2rem;\n  }\n  \n  /* Profile Settings */\n  .cover-photo-container {\n    position: relative;\n  }\n  \n  .cover-photo {\n    height: 200px;\n    background-color: #295478;\n    border-radius: 8px;\n    position: relative;\n  }\n  \n  .profile-photo-container {\n    position: absolute;\n    bottom: -15px;\n    left: 30px;\n  }\n  \n  .profile-photo {\n    width: 100px;\n    height: 100px;\n    background-color: #f8f9fa;\n    border: 4px solid white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n  }\n  \n  .upload-icon {\n    color: #6c757d;\n    font-size: 1.5rem;\n  }\n  \n  .bio-toolbar {\n    border: 1px solid #ddd;\n    border-bottom: none;\n    border-radius: 6px 6px 0 0;\n    padding: 0.5rem;\n    background-color: #f8f9fa;\n  }\n  \n  /* Wishlist Styles */\n  .wishlist-course-card .card {\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    overflow: hidden;\n    transition: box-shadow 0.3s ease;\n  }\n  \n  .wishlist-course-card .card:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n  \n  .wishlist-course-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    min-height: 200px;\n  }\n  \n  .instructor-avatar {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    object-fit: cover;\n  }\n  \n  .instructor-name {\n    font-weight: 500;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .settings-tabs .nav-link {\n      padding: 0.75rem 1rem;\n      font-size: 0.9rem;\n    }\n  \n    .settings-content {\n      padding: 1.5rem;\n    }\n  \n    .profile-photo {\n      width: 80px;\n      height: 80px;\n    }\n  \n    .cover-photo {\n      height: 150px;\n    }\n  \n    .profile-photo-container {\n      bottom: -40px;\n      left: 20px;\n    }\n  \n    .wishlist-course-image {\n      min-height: 150px;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .settings-tabs .nav {\n      flex-wrap: nowrap;\n      overflow-x: auto;\n    }\n  \n    .settings-tabs .nav-link {\n      white-space: nowrap;\n      padding: 0.5rem 0.75rem;\n      font-size: 0.85rem;\n    }\n  \n    .settings-content {\n      padding: 1rem;\n    }\n  \n    .cover-photo {\n      height: 120px;\n    }\n  \n    .profile-photo {\n      width: 70px;\n      height: 70px;\n    }\n  \n    .profile-photo-container {\n      bottom: -35px;\n      left: 15px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
